import { unwrapResult } from '@reduxjs/toolkit';
import moment from 'moment';
import { useCallback } from 'react';

import {
  getUserInfo,
  login as li,
  loginWithCookie as liCookie,
  logout as lo,
  setToken,
} from '../slices/auth';

import useDispatch from './use-dispatch';
import useSelector from './use-selector';

import {
  ClearAllCookies,
  getCookie,
  removeCookie,
  setCookie,
} from '@app/utils/cookie';
import { Token } from '../models/token';
import { CookiesName } from '../utils/constants';

type UseAuth = {
  isAuthenticated: () => boolean;
  checkValidCookie: () => Promise<boolean>;
  login: (username: string, password: string) => Promise<void>;
  logout: () => void;
  hasPermission: (code: string) => boolean;
};

const useAuth = (): UseAuth => {
  const dispatch = useDispatch();

  const isAuthenticated = useCallback((): boolean => {
    const tokenExpiredTime: Date = new Date(
      getCookie(CookiesName.EXPIRED_TIME),
    );
    const cookie = getCookie(CookiesName.NAME);

    console.log('expired', tokenExpiredTime > new Date());

    if (cookie && tokenExpiredTime > new Date()) {
      // checkValidCookie();
      dispatch(getUserInfo())
        .unwrap()
        .then((token) => {
          console.log(token);

          dispatch(setToken({ token }));
        })
        .catch(() => {});
      return true;
    }
    removeCookie(CookiesName.EXPIRED_TIME);
    removeCookie(CookiesName.ROLE);
    removeCookie(CookiesName.NAME);
    // dispatch(lo());
    return false;
  }, [dispatch]);

  const login = async (username: string, password: string): Promise<void> => {
    const token = unwrapResult(await dispatch(li({ username, password })));

    setCookie({
      name: CookiesName.NAME,
      value: token.access_token,
    });

    // setCookie({
    //   name: CookiesName.TOKEN,
    //   value: JSON.stringify(token),
    // });

    setCookie({
      name: CookiesName.EXPIRED_TIME,
      value: moment().add(token.expires_in, 'seconds').format(),
    });

    // dispatch(getUserInfo());
  };

  const logout = useCallback((): void => {
    removeCookie(CookiesName.EXPIRED_TIME);
    removeCookie(CookiesName.ROLE);
    removeCookie(CookiesName.NAME);
    ClearAllCookies();
    dispatch(lo());
  }, [dispatch]);

  const { permissionList } = useSelector((state) => state.auth);
  const hasPermission = useCallback(
    (code: string): boolean => {
      return (
        permissionList.map((p) => p.code).includes('ALL') ||
        permissionList.map((p) => p.code).includes(code)
      );
    },
    [permissionList],
  );

  const checkValidCookie = async (): Promise<boolean> => {
    const result = unwrapResult(await dispatch(liCookie()));
    if (result) {
      const tokenObj = JSON.parse(JSON.stringify(result)) as Token;

      dispatch(
        setToken({
          token: tokenObj,
          // tokenExpiredTime: new Date(tokenObj.expires_in),
        }),
      );

      setCookie({
        name: CookiesName.EXPIRED_TIME,
        value: moment().add(result.expires_in, 'seconds').format(),
      });

      return true;
    } else {
      return false;
    }
  };

  return {
    checkValidCookie,
    isAuthenticated,
    login,
    logout,
    hasPermission,
  };
};

export default useAuth;
